import * as React from 'react';
import autobind from "autobind-decorator";
import { resolve } from "inversify-react";

import { AirlineListDataService } from "src/app/general/airlines/list/airline-list.data";
import { AirlineEditorView } from "./airline-editor.view";

interface AirlineEditorControllerProps {
    value: number | null;
	mode: ControlMode;
	onChanged: (airline?: AirlineSummary) => void;
    setBusy(isBusy: boolean);
    label?: string;
    required?: boolean;
    onGetErrorMessage?: () => Promise<ValidationError[]>;
}

export class AirlineEditorController extends React.Component<AirlineEditorControllerProps, any> {
    protected airlineDataService: AirlineListDataService;

    constructor(props) {
        super(props);
        this.airlineDataService = AirlineListDataService.make();
    }

    @autobind
    protected userQuery(q?: string): Promise<QueryResult<AirlineSummary>> {
        return new Promise<QueryResult<AirlineSummary>>((resolve, reject) => {
            this.props.setBusy(true);
            this.airlineDataService.addFilter('isDeleted', 'eq', false);
            this.airlineDataService.addSorting('title', 'asc', true);
            this.airlineDataService.searchKeywords = q;
            this.airlineDataService.load(query => query)
                .then((items) => {
                    this.props.setBusy(false);
                    resolve({
                        items: items,
                        totalCount: this.airlineDataService.count
                    });
                });
        });
    }

    render() {
        return (
            <AirlineEditorView
                onGetErrorMessage={this.props.onGetErrorMessage}
                airlineRequest={{ query: this.userQuery, dataSet: this.airlineDataService }}
                onChanged={this.props.onChanged}
                value={this.props.value}
                mode={this.props.mode}
                label={this.props.label}
                required={this.props.required}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/general/airlines/parts/airline-editor.controller.tsx